import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'scraps-completed',
  templateUrl: './completed.component.html',
  styleUrls: ['../../tickets/tickets.component.css']
})
export class CompletedComponent implements OnInit {

  @Input() table_id: string;
  @Input() data;
  @Input() bulk: number[] = [];
  public test: Array<number> = [];
  @Input() order;
  @Input() orderby;
  @Output() out: EventEmitter<any>;
  @Output() sortby: EventEmitter<any>;
  @Output() change: EventEmitter<any>;

  public identity;
  public apikey;
  public selectrow = null;

  @ViewChild('childScrollElement') childScrollElement: ElementRef;

  constructor() {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.out = new EventEmitter;
    this.sortby = new EventEmitter;
    this.change = new EventEmitter;
    this.apikey = this.identity.apiCompany;
  }

  stopPropagation(event: WheelEvent): void {
    // Prevent the scroll event from bubbling up to the parent element
    event.stopPropagation();

    //console.log(event);

    // Perform any other scrolling logic you need here
    // For example, you can manually adjust the child's scrollTop property.
    this.childScrollElement.nativeElement.scrollTop += event.deltaY;
  }

  ngOnInit() {
    // console.log(this.table_id);
    console.log(this.data);
  }

  unclick(i, row) {
    this.selectrow = i;
    // if(this.id === 'inventoryTable')
    //   this.saveEmit('Attribute', row[0].value);
  }

  dosclicks(row) {
    console.log(row);
  }

  saveEmit(accion, id, item = null) {
    let send;
    send = {
      evento: accion,
      id: id,
      item: item
    };
    this.out.emit(send);
  }

  sort(by) {
    if (by === this.orderby) {
      if (this.order === 'DESC') {
        this.order = 'ASC';
      } else {
        this.order = 'DESC';
      }
    } else {
      this.orderby = by;
      this.order = 'DESC';
    }

    let order = {
      sort: this.order,
      sortby: this.orderby
    };

    this.sortby.emit(order);
  }

  sorting(by) {
    return this.orderby != by ? 'fa-sort' : (this.order == 'DESC' ? 'fa-sort-desc' : 'fa-sort-asc');
  }

  checkAll() {
    let item;
    for (item of this.data) {
      if (!this.check(item.id)) {
        return false;
      }
    }
    return true;
  }

  check(id) {
    let i;
    for (i of this.bulk) {
      if (i === id) {
        return true;
      }
    }
    return false;
  }

  cleanBulk() {
    this.bulk = [];
    this.change.emit(this.bulk);
  }

  selectAll() {
    let i: number;
    if (this.checkAll()){
      for (i = 0; i < this.data.length; i++) {
        if (this.check(this.data[i].id)) {
          this.selectItem(this.data[i].id);
        }
      }
    } else {
      for (i = 0; i < this.data.length; i++) {
        if (!this.check(this.data[i].id)) {
          this.selectItem(this.data[i].id);
        }
      }
    }
    this.change.emit(this.bulk);
  }

  selectItem(id) {
    // this.bulk = this.test;
    
    let i, find = false;
    for (i = 0; i < this.bulk.length; i ++) {
      if (this.bulk[i] === id) {
        this.bulk.splice(i , 1);
        find = true;
        break;
      }
    }

    if (!find) {
      this.bulk.push(id);
    }
    // this.test = this.bulk;
    this.change.emit(this.bulk);
    
  }

  openReport(reporteID) {
    window.open("https://www.itaderp.com/backend/reports/view-scrap.php?id="+reporteID+"&apikey="+this.apikey, "_blank");
  }

}
